<div class="fx-rates-container">
    <div class="fx-step-nav">
        <ham-tab-navigation
            [navigationItems]="navigationItems"
            [tabsTitles]="[
                'aumico_annual_report_fx_rates_step_period' | i18next,
                'aumico_annual_report_fx_table_step' | i18next
            ]"
            [style]="'underline'"
            [color]="'primary'"
            (tabClick)="onTabClick($event)"
        ></ham-tab-navigation>
    </div>

    <ng-container *ngIf="selectedTab === stepPeriodRates">
        <div class="fx-estv-hint">
            <span class="ham-icon icon">
                <i class="info-outline-icon"></i>
            </span>
            <span>
                {{ 'aumico_annual_report_fx_rates_estv_hint' | i18next }}
                <a [href]="estvUrl" target="_blank" rel="noopener noreferrer">
                    {{ 'aumico_annual_report_fx_rates_estv_link' | i18next }} &#8599;
                </a>
            </span>
        </div>

        <form [formGroup]="form">
            <!-- Current year -->
            <div class="fx-card">
                <div class="fx-card-header">
                    <h3>{{ 'aumico_annual_report_fx_rates_current_year' | i18next }}</h3>
                    <span class="fx-pair-badge">{{ currencyPairLabel }}</span>
                </div>
                <div class="fx-card-body">
                    <div class="fx-rate-fields">
                        <div class="fx-field">
                            <label
                                >{{ 'aumico_annual_report_fx_rates_closing_rate' | i18next }}
                                {{ currentYearClosingDate }} <span class="fx-required">*</span></label
                            >
                            <input
                                hamInput
                                type="number"
                                [decimalPlaces]="rateDecimalPlaces"
                                formControlName="currentYearClosing"
                            />
                        </div>
                        <div class="fx-field">
                            <label
                                >{{ 'aumico_annual_report_fx_rates_average_rate' | i18next }} {{ currentYearLabel }}
                                <span class="fx-required">*</span></label
                            >
                            <input
                                hamInput
                                type="number"
                                [decimalPlaces]="rateDecimalPlaces"
                                formControlName="currentYearAverage"
                            />
                        </div>
                    </div>

                    <div class="fx-import-hint">
                        <span>{{ 'aumico_annual_report_fx_rates_import_label' | i18next }}</span>
                        <button type="button" class="fx-guide-link" (click)="showRateFileGuide = true">
                            <span class="ham-icon"><i class="info-outline-icon"></i></span>
                            {{ 'aumico_annual_report_fx_rates_guide_open' | i18next }}
                        </button>
                    </div>
                    <div
                        class="fx-dropzone"
                        (click)="currentYearFileInput.click()"
                        (drop)="onFileDropped($event, 'currentYear')"
                        (dragover)="onDragOver($event)"
                    >
                        <span class="fx-dropzone-main">{{ 'aumico_annual_report_fx_rates_dropzone' | i18next }}</span>
                        <span class="fx-dropzone-format">{{
                            'aumico_annual_report_fx_rates_dropzone_format'
                                | i18next : { functional: functionalCurrencyName, display: displayCurrencyName }
                        }}</span>
                        <input
                            #currentYearFileInput
                            type="file"
                            accept=".xlsx,.xls"
                            hidden
                            (change)="onFileSelected($event, 'currentYear'); currentYearFileInput.value = ''"
                        />
                    </div>
                    <p class="fx-import-error" *ngIf="importErrors.currentYear as error">
                        {{ error.messageKey | i18next : error.params }}
                    </p>
                </div>
            </div>

            <!-- Previous year -->
            <div class="fx-card">
                <div class="fx-card-header">
                    <h3>{{ 'aumico_annual_report_fx_rates_previous_year' | i18next }}</h3>
                    <!-- One switch for the whole prior year: the period rates here AND the
                         per-account historical rates in the conversion table. -->
                    <button
                        type="button"
                        role="switch"
                        class="fx-lock-toggle"
                        [class.locked]="previousYearLocked"
                        [attr.aria-checked]="previousYearLocked"
                        (click)="onLockToggleClicked()"
                    >
                        <span class="fx-lock-label">
                            {{
                                (previousYearLocked
                                    ? 'aumico_annual_report_fx_rates_locked'
                                    : 'aumico_annual_report_fx_rates_unlocked'
                                ) | i18next
                            }}
                        </span>
                        <span class="fx-lock-track" aria-hidden="true">
                            <span class="fx-lock-thumb"></span>
                        </span>
                    </button>
                    <span class="fx-pair-badge">{{ currencyPairLabel }}</span>
                </div>
                <div class="fx-card-body">
                    <p class="fx-lock-scope">{{ 'aumico_annual_report_fx_rates_lock_scope' | i18next }}</p>
                    <div class="fx-rate-fields">
                        <div class="fx-field">
                            <label
                                >{{ 'aumico_annual_report_fx_rates_closing_rate' | i18next }}
                                {{ previousYearClosingDate }} <span class="fx-required">*</span></label
                            >
                            <input
                                hamInput
                                type="number"
                                [decimalPlaces]="rateDecimalPlaces"
                                formControlName="previousYearClosing"
                            />
                        </div>
                        <div class="fx-field">
                            <label
                                >{{ 'aumico_annual_report_fx_rates_average_rate' | i18next }} {{ previousYearLabel }}
                                <span class="fx-required">*</span></label
                            >
                            <input
                                hamInput
                                type="number"
                                [decimalPlaces]="rateDecimalPlaces"
                                formControlName="previousYearAverage"
                            />
                        </div>
                    </div>

                    <ng-container *ngIf="!previousYearLocked">
                        <div class="fx-import-hint">
                            <span>{{ 'aumico_annual_report_fx_rates_import_label' | i18next }}</span>
                            <button type="button" class="fx-guide-link" (click)="showRateFileGuide = true">
                                <span class="ham-icon"><i class="info-outline-icon"></i></span>
                                {{ 'aumico_annual_report_fx_rates_guide_open' | i18next }}
                            </button>
                        </div>
                        <div
                            class="fx-dropzone"
                            (click)="previousYearFileInput.click()"
                            (drop)="onFileDropped($event, 'previousYear')"
                            (dragover)="onDragOver($event)"
                        >
                            <span class="fx-dropzone-main">{{
                                'aumico_annual_report_fx_rates_dropzone' | i18next
                            }}</span>
                            <span class="fx-dropzone-format">{{
                                'aumico_annual_report_fx_rates_dropzone_format'
                                    | i18next : { functional: functionalCurrencyName, display: displayCurrencyName }
                            }}</span>
                            <input
                                #previousYearFileInput
                                type="file"
                                accept=".xlsx,.xls"
                                hidden
                                (change)="onFileSelected($event, 'previousYear'); previousYearFileInput.value = ''"
                            />
                        </div>
                        <p class="fx-import-error" *ngIf="importErrors.previousYear as error">
                            {{ error.messageKey | i18next : error.params }}
                        </p>
                    </ng-container>
                </div>
            </div>
        </form>
    </ng-container>

    <ng-container *ngIf="selectedTab === stepConversionTable">
        <aumico-fx-conversion-table
            [annualReport]="currentAnnualReport"
            [finStatements]="finStatements"
            [fxTranslation]="conversionFxTranslation"
            [previousYearLocked]="previousYearLocked"
            (methodChange)="onMethodChange($event)"
            (historicalEdit)="onHistoricalEdit($event)"
            (roundingAccountChange)="onRoundingAccountChange($event)"
        ></aumico-fx-conversion-table>
    </ng-container>
</div>

<!-- The historical editor for one account-year. -->
<aumico-fx-historical-modal
    *ngIf="historicalRequest != null"
    [request]="historicalRequest"
    [functionalCurrencyName]="functionalCurrencyName"
    [displayCurrencyName]="displayCurrencyName"
    (saveClicked)="onHistoricalSave($event)"
    (cancelClicked)="onHistoricalCancel()"
></aumico-fx-historical-modal>

<ng-template #footerTemplate>
    <aum-action-bar-pure
        [extraActionButtons]="footerExtraButtonActions"
        nextButtonPrefixText="{{ nextStepPrefix | i18next }}"
        nextButtonText="{{ nextButtonLabelKey | i18next }}"
        [nextButtonAction]="proceedButtonClicked"
        [nextButtonRouterLink]="nextButtonRouterLink"
        [nextButtonDisabled]="disableProceedButton"
        backButtonPrefixText="{{ previousStepPrefix | i18next }}"
        backButtonText="{{ groupingMaskingLabel | i18next }}"
        backButtonRouterLink="../{{ groupingMaskingPath }}"
        [backButtonIcon]="previousStepIcon"
    ></aum-action-bar-pure>
</ng-template>

<aumico-fx-rate-file-guide
    *ngIf="showRateFileGuide"
    [functionalCurrencyName]="functionalCurrencyName"
    [displayCurrencyName]="displayCurrencyName"
    (closed)="showRateFileGuide = false"
></aumico-fx-rate-file-guide>

<ham-modal
    *ngIf="showImportConfirmation && pendingSeries != null"
    [title]="'aumico_annual_report_fx_rates_import_confirm_title' | i18next"
    [saveText]="'aumico_annual_report_fx_rates_import_confirm_action' | i18next"
    [showCancelButton]="true"
    [cancelText]="'aumico_button_cancel' | i18next"
    (save)="onImportConfirmed()"
    (cancel)="onImportDeclined()"
>
    <p class="fx-confirm-intro">{{ 'aumico_annual_report_fx_rates_import_confirm_body' | i18next }}</p>
    <div class="fx-confirm-rates">
        <div class="fx-confirm-row">
            <span>{{ 'aumico_annual_report_fx_rates_average_rate' | i18next }}</span>
            <span class="fx-confirm-value">
                1 {{ functionalCurrencyName }} = {{ pendingSeries.average | number : '1.5-5' }}
                {{ displayCurrencyName }}
            </span>
        </div>
        <div class="fx-confirm-row" *ngIf="pendingSeries.closing != null">
            <span>{{ 'aumico_annual_report_fx_rates_closing_rate' | i18next }}</span>
            <span class="fx-confirm-value">
                1 {{ functionalCurrencyName }} = {{ pendingSeries.closing | number : '1.5-5' }}
                {{ displayCurrencyName }}
            </span>
        </div>
    </div>
    <p class="fx-confirm-note" *ngIf="pendingSeries.closingDate != null">
        {{
            'aumico_annual_report_fx_rates_import_closing_last_business_day'
                | i18next : { date: (pendingSeries.closingDate | date : 'dd.MM.yyyy') }
        }}
    </p>
    <p class="fx-confirm-warning" *ngIf="pendingSeries.closing == null">
        {{ 'aumico_annual_report_fx_rates_import_no_closing' | i18next }}
    </p>
</ham-modal>

<ham-modal
    *ngIf="showUnlockConfirmation"
    [title]="'aumico_annual_report_fx_rates_unlock_confirm_title' | i18next"
    [saveText]="'aumico_annual_report_fx_rates_unlock_confirm_action' | i18next"
    [saveVariant]="'red'"
    [showCancelButton]="true"
    [cancelText]="'aumico_button_cancel' | i18next"
    (save)="onUnlockConfirmed()"
    (cancel)="onUnlockDeclined()"
>
    <p class="fx-confirm-intro">{{ 'aumico_annual_report_fx_rates_unlock_confirm_body' | i18next }}</p>
</ham-modal>
